import  {__extends} from './eXcell';
import  eXcell_co from './eXcell_co';

var eXcell_coro = (function (_super) {
    __extends(eXcell_coro, _super);
    function eXcell_coro(a) {
        _super.call(this, a);
        this.editable = false;
    }
    return eXcell_coro;
})(eXcell_co);
window.eXcell_coro = eXcell_coro;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_coro.js